import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { ButtonType } from 'components/UI/Buttons/Button/Button';
import ButtonWithArrow from 'components/UI/Buttons/ButtonWithArrow/ButtonWithArrow';

import styles from './SelectionButton.module.scss';

type PropsType = Omit<ButtonType, 'classes' | 'model'> & {
  label: string;
  open: boolean;
};

function SelectionButton(
  { label, open, children, className, ...props }: PropsType,
  ref
): JSX.Element {
  return (
    <ButtonWithArrow
      ref={ref}
      model={'transparent'}
      className={classNames(styles.button, className)}
      classes={{
        arrow: classNames(styles.arrow, { [styles.open]: open }),
      }}
      {...props}
    >
      <span className={styles.label}>{label}</span>
      {children}
    </ButtonWithArrow>
  );
}

export default forwardRef(SelectionButton);
